import React, { useEffect, useRef, useState } from 'react';
import api from '../api';
import NfseFiscalFields from '../components/NfseFiscalFields';
const empty = { nbs: '', indOp: '', cst: '', cClassTrib: '', issRate: '', simplesRate: '', regApTribSN: '1', issWithholding: '' };
export default function CompanyNfseTaxSettings() {
  const [values, setValues] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const edited = useRef(false);
  useEffect(() => {
    let active = true;
    api.get('/company/nfse-profile').then(response => {
      if (active && !edited.current) setValues(Object.fromEntries(Object.keys(empty).map(key => [key, response.data?.[key] ?? (key === 'regApTribSN' ? '1' : '')])));
    }).catch(() => { if (active) setError('Não foi possível consultar os padrões fiscais.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  const save = async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError(''); setMessage('');
    try {
      await api.put('/company/nfse-profile', values);
      setMessage('Padrões fiscais salvos.');
      window.dispatchEvent(new Event('nfse-settings-updated'));
    } catch (failure) { setError(failure?.response?.data?.error || 'Não foi possível salvar os padrões fiscais.'); }
    finally { setBusy(false); }
  };
  return <form onSubmit={save} className="space-y-4 rounded-xl border border-slate-200 bg-white p-5" aria-label="Padrões fiscais gerais">
    <h2 className="text-base font-semibold text-slate-900">Padrões fiscais gerais</h2>
    <label className="block text-sm font-medium text-slate-700">Apuração de tributos do emitente (Simples Nacional)
      <select value={values.regApTribSN} disabled={busy} onChange={event => { edited.current = true; setValues(previous => ({ ...previous, regApTribSN: event.target.value })); }}
        className="mt-1 block min-h-[42px] w-full max-w-xl rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm">
        <option value="1">Federais e ISS pelo Simples Nacional (DAS)</option>
        <option value="2">Federais pelo Simples; ISS fora do Simples</option>
        <option value="3">Federais e ISS fora do Simples Nacional</option>
      </select>
    </label>
    <label className="block text-sm font-medium">ISS retido pelo tomador
      <select aria-label="Retenção padrão do ISS" value={values.issWithholding} onChange={event => { edited.current = true; setValues(previous => ({...previous, issWithholding:event.target.value})); }} className="mt-1 block rounded-lg border p-2">
        <option value="">Definir em cada nota</option><option value="1">Não</option><option value="2">Sim</option>
      </select>
    </label>
    <NfseFiscalFields values={values} onChange={(key, value) => { edited.current = true; setValues(previous => ({ ...previous, [key]: value })); }} disabled={busy}/>
    {loading && <p role="status">Carregando...</p>}
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    {message && <p role="status" className="text-sm text-slate-600">{message}</p>}
    <button type="submit" disabled={busy || loading} className="min-h-[44px] rounded-lg bg-blue-600 px-4 text-sm font-semibold text-white disabled:opacity-50">{busy ? 'Salvando...' : 'Salvar padrões'}</button>
  </form>;
}
